import { rootNamespace } from "config";
import { fetchStylesheet } from "lib/helpers";
import { TreeContext } from "pages/Editor";
import { useContext, useState, useEffect, Fragment, useRef } from "react";
import FramePortal from "./Preview/components/FramePortal";
import RenderTree from "./Preview/components/RenderTree";
import _ from "lodash";
import CodeEditor from "./Preview/components/CodeEditor";

function StyleLoader() {
  const { pages, subscribe } = useContext(TreeContext);
  const [stylesheets, setStylesheets] = useState([]);
  useEffect(() => {
    // TODO: check if this makes reload everytime. might not be favourable
    // issue #6
    const stylesheets = _.get(pages, "stylesheets", []);
    if (stylesheets.length) {
      const promises = stylesheets.map(fetchStylesheet);
      Promise.all(promises).then((rsp) => {
        setStylesheets(rsp);
      });
    }
  }, [pages]);
  useEffect(() => {
    const addStylesheet = (link) => {
      fetchStylesheet(link).then((css) =>
        setStylesheets(stylesheets.concat(css))
      );
    };
    const removeStylesheet = (title) => {
      setStylesheets(stylesheets.filter((s) => s.title !== title));
    };
    const listeners = [
      subscribe(rootNamespace, "ADD_STYLESHEET", addStylesheet),
      subscribe(rootNamespace, "REMOVE_STYLESHEET", removeStylesheet),
    ];
    return () => listeners.forEach((unsubscribe) => unsubscribe());
  }, [stylesheets, subscribe]);
  return stylesheets.map(({ title, css }, key) => (
    <style {...{ title, key }}>{css}</style>
  ));
}

export default function Editor() {
  const ref = useRef();
  const { tree, pages, update, selection, publish, subscribe } =
    useContext(TreeContext);
  // issue #6
  const body = _.get(tree, "body", {});
  const scripts = _.get(pages, "scripts", []);
  const onDrop = (e) => {
    e.preventDefault();
    if (Object.keys(body).length === 0) {
      let data = e.dataTransfer.getData("text/plain");
      const { item } = JSON.parse(data);
      data = { item, path: "root" };
      publish(rootNamespace, "ADD", data);
    }
  };
  const onDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
  };
  const onLoad = () => {
    // issue #5
    // auto select component
    // pubSub.publish(rootNamespace, 'SELECT', 'abc.children.2.children.1')
  };
  const treeApi = {
    tree,
    context: "preview",
    editable: true,
    subscribe,
    publish,
    iframe: ref,
    update,
    selection,
    pages,
  };
  return (
    <div className="pw">
      <TreeContext.Provider value={treeApi}>
        {
          <FramePortal title="Editor" {...{ ref, onLoad }}>
            {[
              <Fragment key="0">
                <StyleLoader />
                <link
                  rel="stylesheet"
                  type="text/css"
                  href="https://unpkg.com/font-awesome@4.7.0/css/font-awesome.min.css"
                />
                <link rel="stylesheet" type="text/css" href="/iframe.css" />
              </Fragment>,
              <Fragment key="1">
                <div onDrop={onDrop} onDragOver={onDragOver} className="cx">
                  <RenderTree {...{ tree }} />
                </div>
                <script src="/iframe.js" />
                {scripts.map((src, key) => (
                  <script {...{ key, src }} />
                ))}
              </Fragment>,
            ]}
          </FramePortal>
        }
      </TreeContext.Provider>
      <CodeEditor />
    </div>
  );
}
